import { registerAction2 } from './actions.js';
import '../../instantiation/common/instantiation.js';
import { MenuHiddenStatesReset } from './menuResetAction.js';
import './menuService.js';
registerAction2(MenuHiddenStatesReset);
